import * as THREE from 'three'
import { Suspense, useState, useEffect } from 'react'
import { Canvas, useThree, useFrame } from '@react-three/fiber'
import { Text, Environment } from '@react-three/drei'
import Noodles from './Noodles'
import { useTransition, animated } from '@react-spring/three'

// import Environment from "@react-three/drei/Environment";
const titlesColl = [
  "MOLTEN SILVER FLOWS ALONG",
  "ETERNALIZE THE MUTATION",
  "AND PRESERVE THE ETHEREAL",
  "SUBSTANCE FLUCTUATES",
  "IS IT SOLID ?",
  "OR IS IT LIQUID ?",
  "SUBSTANCE NO LONGER HOLDS",
  "STAND IN ITS INTRICACY",
  "ENCAPSULATE AND IMMORTALIZE THE FLEETING",
  "YIELD TO FLUIDITY, SURRENDER TO CHAOS ",
  "THE STATES OF MATTER ARE UNIFIED"
]
const environments = [
  // 'soliltude_1k.hdr',
  // 'neon_photostudio_1k.hdr',
  // 'studio_small_09_1k.hdr',
  // 'empty_warehouse_01_1k.hdr'
  'peppermint_powerplant_2_1k.hdr'
]
const environment = environments[Math.floor(Math.random() * environments.length)];

export default function App() {  
  return (
    <Canvas dpr={[1, 2]} camera={{ position: [0, 0, 10], fov: 22 }}>
      <Bg />
      <Suspense fallback={null}>
        <Environment files={environment}/>
        <Noodles />
        {/* {/* <spotLight color="#00FF48" intensity={.45} position={[0, 30, 40]} /> */}
        {/* <spotLight color="#00FF48" intensity={.45} position={[-50, 30, 40]} /> */}
        <ambientLight color="#ff0000" intensity={.45} position={[0, 30, 40]} />
        <ambientLight color="#FFF" intensity={.45} position={[-50, 30, 40]} />
        <Caption active={true}>
        </Caption>
        <Rig />
      </Suspense>
    </Canvas>
  )
}

function Caption() {
  const [titles, setTitles] = useState([0]);
  const { width } = useThree((state) => state.viewport)
  
  let interval;
  
  useEffect(() => {
    interval = setInterval(() => {
      setTitles((titles) => (titles[0] < titlesColl.length - 1) ? [titles[0] + 1] : [0])
    }, 6000)
    // cleanup
    return () => {
      clearInterval(interval)
    }
  }, []);
  // console.log(titles)
  // const transitions = useTransition(titles, {
  //   from: { o: 0},
  //   enter: { o: 1},
  //   leave: { o: 0},
  //   config: { duration: 350 },
  //   exitBeforeEnter: true,
  // })
  // useEffect(() => {
  //   console.log('interval 2')
  //   let handleResize = () => {
  //     console.log(interval)
  //     setTitles(...titles)
  //   }
  //   document.addEventListener('visibilitychange', handleResize)
  //   // cleanup
  //   return () => {
  //     console.log('cleaning up visibility change event handler')
  //     document.removeEventListener('visibilitychange', handleResize)
  //   }
  // }, [])

  // return transitions(({ o }, item) => {
    return (
        <Text
          position={[0, 0, -5]}
          lineHeight={1.2}
          textAlign="center"
          font="/TAN-PEARL.ttf"
          fontSize={0.4 - (width * 0.01)}
          material-toneMapped={false}
          anchorX="center"
          anchorY="middle"
          maxWidth={width * 1.3}
          color="#00FF48"
        >
          {/* {titlesColl[item]} */}
        {titlesColl[titles[0]]}
          {/* <animated.meshPhongMaterial
            // opacity={o}
            color="#00FF48"
            attach="material"
          /> */}
        </Text>
    )
  // })
}

function Rig({ v = new THREE.Vector3() }) {
  return useFrame((state) => {
    state.camera.position.lerp(v.set(state.mouse.x / 2, state.mouse.y / 2, 10), 0.05)
  })
}

function Bg() {
  return (
    <mesh scale={100}>
      <boxGeometry args={[1, 1, 1]} />
    </mesh>
  )
}
